import axiosPost from "./axiosPost";
export const MIAUsuarioCheck = async (dni, typeDocument) => {

    const body = {
        service: "MIAUsuarioCheck",
        params: {
            tipoDeDocumentoId: typeDocument,
            usuarioNroDeDocumentoX: dni,
        },
    };

    const result = await axiosPost(
        body,
        null
    );
    return result.status;
};
